const USER = {
  SET_USER_DATA: 'user/set_data',
  SET_TEST_USER_DATA: 'user/set_test_data',
  SET_SKIP_INFO: 'user/set_skip_info',
};

const initialState = {};

export const setTestUserData = (data) => ({
  type: USER.SET_TEST_USER_DATA,
  payload: data,
});

export const setUserData = (data) => ({
  type: USER.SET_USER_DATA,
  payload: data,
});

export const setSkipInfo = (data) => ({
  type: USER.SET_SKIP_INFO,
  payload: data,
});

const userReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER.SET_USER_DATA:
      return {
        ...state,
        ...payload.user,
        shippingAddress: payload.shippingAddress,
        subscriptions: payload.subscriptions,
        billing: payload.billing,
        select: payload.select,
        tier: payload.tier,
      };

    case USER.SET_TEST_USER_DATA:
      return {
        ...state,
        testUsers: {
          ...state.testUsers,
          [payload.id]: {
            ...payload.user.user,
            shippingAddress: payload.user.shippingAddress,
            subscriptions: payload.user.subscriptions,
            billing: payload.user.billing,
          },
        },
      };

    case USER.SET_SKIP_INFO:
      return {
        ...state,
        hasSkipped: payload.hasSkipped,
        skipEligible: payload.skipEligible,
      };

    default:
      return state;
  }
};

export default userReducer;
